<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <img :src="logo" />
      </div>

      <el-form-item prop="username">
        <el-input
          ref="username"
          v-model.trim="loginForm.username"
          placeholder="用户名"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        >
          <template slot="prepend">
            <!-- <svg-icon icon-class="user" /> -->
            用户名
          </template>
        </el-input>
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="大写锁定已开启" placement="right" manual>
        <el-form-item prop="password">
          <el-input
            :key="passwordType"
            ref="password"
            v-model.trim="loginForm.password"
            :type="passwordType"
            placeholder="用户密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
          >
            <template slot="prepend">
              <!-- <svg-icon icon-class="password" /> -->
              密&#12288;码
            </template>
          </el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-tooltip>
      <el-form-item prop="captcha" class="m-b-15 input-flex-append">
        <el-input
          ref="captcha"
          tabindex="3"
          placeholder="图形验证码"
          v-model="loginForm.captcha"
          @keyup.enter.native="handleLogin"
        >
          <template slot="prepend">验证码</template>
        </el-input>
        <img
          :src="`${baseUrl}/captcha?t=${captchaTime}`"
          alt="验证码"
          width="120px"
          @click="refreshTime"
        />
      </el-form-item>
      <router-link to="/resetPassword" class="reset">忘记密码？</router-link>
      <el-form-item class="m-t-15">
        <el-button
          :loading="loading"
          class="width-full"
          tabindex="4"
          type="primary"
          @click.native.prevent="handleLogin"
        >登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  Form, FormItem, Tooltip, Input
} from 'element-ui';
import { validUsername } from '@/utils/validate';
import { login } from '@/api';
import pattern from '@/utils/pattern';
import env from '@/api/env';
import fetchCode from '@/utils/fetchCode';
import LOGO from '../assets/images/logo.png';

export default {
  name: 'Login',
  components: {
    ElTooltip: Tooltip,
    ElForm: Form,
    ElInput: Input,
    ElFormItem: FormItem
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入正确的用户密码'));
      } else {
        callback();
      }
    };
    return {
      baseUrl: env.baseUrl,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        remember_me: false
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [
          {
            required: true,
            message: '请填写正确的验证码',
            trigger: 'blur',
            pattern: pattern.captcha
          }
        ]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      logo: LOGO,
      captchaTime: new Date().getTime()
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.isRest) return;
    if (this.loginForm.username === '') {
      this.$refs.username.focus();
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus();
    }
  },
  methods: {
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if ((shiftKey && (key >= 'a' && key <= 'z')) || (!shiftKey && (key >= 'A' && key <= 'Z'))) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          login({
            ...this.loginForm,
            remember_me: true
          })
            .then(({ data }) => {
              if (data.access_token) {
                this.$store.dispatch('user/setAuth', data).then(() => {
                  this.$store.dispatch('msg/showMsg', data.msg || '登录成功');
                  this.$router.push(`/${this.$store.state.user.info.id}`);
                });
              } else {
                this.$store.dispatch('msg/showErrorMsg', data.msg || '登录失败');
              }
            })
            .catch(e => {
              this.loading = false;
              if (e && e.data && (e.data.error_code === fetchCode.CAPTCHA_ERROR || e.data.error_code === fetchCode.TIMER_OUT)) {
                this.refreshTime();
                this.loginForm.captcha = '';
                this.$refs.captcha.focus();
              }
            });
          return true;
        }
        return false;
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    refreshTime() {
      this.captchaTime = new Date().getTime();
    }
  }
};
</script>

<style lang="less">
/* 修复input 背景不协调 和光标变色 */

@bg: #283443;
@light_gray: #fff;
@cursor: #fff;

/* reset element-ui css */
.login-container {
  height: 100vh;
  &::after {
    content: '';
    min-height: inherit;
    font-size: 0;
  }
  .reset {
    color: @main-blue;
    font-size: 14px;
  }
  .input-flex-append .el-form-item__content {
    >.el-input-group {
      width: 320px;
      margin-right: 5px;
    }
    img {
      width: 120px;
      padding:  5px 0;
    }
  }
  .el-input {
    display: inline-table;
    height: 47px;
    input {
      background: transparent;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 47px;
      line-height: normal;
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
}
</style>

<style lang="less" scoped>
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;

.login-container {
  min-height: 100vh;
  width: 100%;
  background: @bg url(../assets/images/login_bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-form {
    width: 520px;
    padding: 0 35px;
    overflow: hidden;
    background: #fff;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 0 5px 0 15px;
    color: @dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    text-align: center;
    background-color: @main-blue;
    padding: 10px 0;
    margin: 20px 0 10px 0;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: @dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
